import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["map", "lat", "lng"]

  connect() {
    const L = window.L
    this.map = L.map(this.mapTarget).setView([46.7111, 1.7191], 6)
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution: "© OpenStreetMap"
    }).addTo(this.map)
    this.marker = null
    this.map.on("click", (e) => this.pick(e.latlng))
  }

  pick(latlng) {
    if (this.marker) this.map.removeLayer(this.marker)
    const L = window.L
    this.marker = L.marker([latlng.lat, latlng.lng]).addTo(this.map)
    this.latTarget.value = latlng.lat.toFixed(6)
    this.lngTarget.value = latlng.lng.toFixed(6)
  }
}


